import React from "react";
import { RefreshIcon, StyledIconButton } from "@aureskonnect/react-ui";
import { Card } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { uid } from "react-uid";

import {
    generalConfigStore,
    setProjectFiles,
    setIsResetOneImageButtonClicked,
} from "@store";

import { getImageContentById } from "@helpers/general";

import { Uploader } from "@components/Uploader";
import { DynamicSvgComponent } from "@components/Common/DynamicSvgComponent";

type PropsType = {
    item: ActionsButtonsDesignItemType;
    index: number;
    setItems: React.Dispatch<
        React.SetStateAction<ActionsButtonsDesignItemType[]>
    >;
};

export function ActionButtonItemWrapper({
    item,
    index,
    setItems,
}: PropsType): JSX.Element {
    const { t } = useTranslation();

    const {
        selectedActionsButtons2Language,
        project: { files: images },
        imageKey,
        isResetOneImageButtonClicked,
    } = useSnapshot(generalConfigStore);

    const [cardImageKey, setCardImageKey] = React.useState<string>("");

    const imageContent = getImageContentById(
        item.id,
        images,
        selectedActionsButtons2Language
    );
    const imageSrc =
        imageContent?.includes("http") || imageContent?.includes("https")
            ? imageContent
            : `./images/${imageContent}`;

    function handleResetImagesOnClickEvent(id: string) {
        const imagesArray = [...images];

        const image = imagesArray.find((element) => element.id === id);
        if (image !== undefined) {
            const imageIndex = imagesArray.indexOf(image);

            const localContent = image.content as ImageItemLanguagesType;
            imagesArray[imageIndex] = {
                ...image,
                content: {
                    ...localContent,
                    [selectedActionsButtons2Language as string]: {
                        ...localContent[
                            selectedActionsButtons2Language as string
                        ],
                        path: localContent[
                            selectedActionsButtons2Language as string
                        ].defaultImage as string,
                    },
                } as ImageItemLanguagesType,
            };
        }

        setProjectFiles(imagesArray);
        setCardImageKey(uid(imagesArray));
    }

    return (
        <div
            className="d-flex flex-column justify-content-center align-items-start cursor__clz"
            key={index}
            style={{ gap: "10px" }}
        >
            <div
                className="d-flex text-muted"
                style={{
                    color: "#B2B2B2",
                    marginLeft: "5px",
                    fontSize: "14px",
                }}
            >
                {t(item.name)}
            </div>

            <Card
                className={`ksk_btn_expertTakeOrderAction${item.name
                    .split(" ")
                    .map((word, i) => {
                        return (
                            word.charAt(0).toUpperCase() +
                            word.slice(1).toLowerCase()
                        );
                    })
                    .join("")}`}
                style={{
                    width: "270px",
                    height: "220px",
                    borderRadius: "20px",
                    display: "grid",
                    gridTemplateRows: "50px 100px auto",
                }}
            >
                <div className="d-flex justify-content-end">
                    <StyledIconButton
                        title={t("Reset to default image")}
                        outline={true}
                        variant="danger"
                        className="m-0 p-0"
                        icon="RefreshIcon"
                        style={{ height: "20%", width: "20px" }}
                        onClick={() => {
                            handleResetImagesOnClickEvent(item.id);
                            setIsResetOneImageButtonClicked(true);
                        }}
                    >
                        <RefreshIcon height={20} width={20} />
                    </StyledIconButton>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                    {imageSrc.includes("png") ||
                    imageSrc.includes("webp") ||
                    imageSrc.includes("jpg") ? (
                        <img
                            alt="actionButton"
                            src={imageSrc}
                            style={{
                                maxWidth: "95%",
                                maxHeight: "50%",
                            }}
                        />
                    ) : (
                        <DynamicSvgComponent
                            nameSvg={imageContent as string}
                            width={"95%"}
                            height={"50%"}
                            selectedLanguage={selectedActionsButtons2Language}
                        />
                    )}
                </div>

                <div className="d-flex justify-content-center align-items-center">
                    <StyledIconButton
                        style={{
                            width: "50px",
                            height: "50px",
                            boxShadow: "0px 3px 6px #00000029",
                        }}
                    >
                        <Uploader
                            key={
                                isResetOneImageButtonClicked === false
                                    ? imageKey
                                    : cardImageKey
                            }
                            id={item.id}
                            activeLanguage={selectedActionsButtons2Language}
                        />
                    </StyledIconButton>
                </div>
            </Card>
        </div>
    );
}
